import Vue, { PropType } from 'vue';
import IconBase from '../icon';
import { IconProps, SVGJson } from '../utils/types';
import useSizeProps from '../utils/use-size-props';

const element: SVGJson = {"tag":"svg","attrs":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"children":[{"tag":"path","attrs":{"fill":"props.filledColor","d":"M11.9999 1.9165L22.0999 6.12484L11.9999 10.3332L1.8999 6.12484L11.9999 1.9165ZM1.9999 9.9802L11.9999 14.2881L21.9999 9.9802V12.1611L11.9999 16.4657L1.9999 12.1611L1.9999 9.9802ZM1.9999 15.9802L11.9999 20.2881L21.9999 15.9802V18.1611L11.9999 22.4657L1.9999 18.1611L1.9999 15.9802Z"}}]};

const LayersFilled = Vue.extend<IconProps>({
  name: 'LayersFilledIcon',
  functional: true,
  props: {
    size: {
      type: String,
    },
    onClick: {
      type: Function as PropType<IconProps['onClick']>,
    },
    fillColor: {
      type: [String, Array] as PropType<IconProps['fillColor']>,
    },
    strokeColor: {
      type: [String, Array] as PropType<IconProps['fillColor']>,
    },
    strokeWidth: {
      type: Number,
      default: 2
    }
  },
  render(createElement, context) {
    const { props, data } = context;
    const { size, ...otherProps } = props;

    const { className, style } = useSizeProps(size);
    const fullProps = {
      ...otherProps || {},
      id: 'layers-filled',
      icon: element,
      staticClass: className,
      style,
    };
    data.props = fullProps;
    return createElement(IconBase, data);
  },
});

export default LayersFilled;
